import CarbonFootprintTransportField from './CarbonFootprintTransportField';

export default CarbonFootprintTransportField;
